export default __webpack_public_path__ + "static/media/cake9.e98a319d.jpeg";